<template lang="pug">

.image-collection-container
  slider(
    carouselType='imageCollection'
    :containerClass='containerClass'
    :autoplay='false'
    :items='1'
    :slideBy='1'
    :speed='300'
    :nav='true'
    :showArrows='!isMobile'
    :responsiveOptions='{}'
  )
    .wrapper(slot='slider-content')
      .imageCollectionSlider(:class='containerClass')
        a(v-for='image, index in images', v-if='image.attributes["link_url"] !== ""' :href='image.attributes["link_url"]')
          img.slide-img(:src='image.attributes["image_url"]' :alt='image.attributes["alt_text"]')
  .clearfix
</template>
<script>
import Slider from '../../../shared/slider.vue'
export default {
  components: {
    Slider
  },
  props: {
    id: { type: String, default: null },
    images: { type: Array, default: () => [] }
  },
  computed: {
    containerClass () {
      return `img-collection-${this.id}`
    },
    isMobile: () => vueSupport.isMobile
  }
}
</script>

<style lang='scss'>
  .image-collection-container {
    .slider-container {
      .arrow {
        background: rgba(255, 255, 255, 0.5);
        opacity: 0;
        -webkit-transition: all .5s ease-in-out;
        -moz-transition: all .5s ease-in-out;
        -ms-transition: all .5s ease-in-out;
        -o-transition: all .5s ease-in-out;
        transition: all .5s ease-in-out;
        z-index: 600;
      }

      &:hover {
        .arrow {
          opacity: 1;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .clearfix {
    clear: both;
  }

  .image-collection-container {
    @include media-breakpoint-only(xs) {
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .slide-img {
    width: 100%;
  }
</style>
